import React from "react";
import ReactMarkdown from "react-markdown";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

export const FAQCategory = ({ category }) => {
  return (
    <div className="lg:grid lg:grid-cols-3 lg:gap-8">
      <div>
        <h2 className="text-3xl font-semibold text-gray-900">
          {category.title}
        </h2>
        <p className="mt-4 text-lg text-gray-500">{category.description}</p>
      </div>
      <div className="mt-12 lg:mt-0 lg:col-span-2">
        <dl className="space-y-8">
          {category.faqs.map((faq, index) => (
            <Disclosure as="div" key={index}>
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                      <span className="font-medium text-gray-900">
                        {faq.question}
                      </span>
                      <span className="ml-6 h-7 flex items-center">
                        <ChevronDownIcon
                          className={classNames(
                            open ? "-rotate-180" : "rotate-0",
                            "h-6 w-6 transform",
                          )}
                          aria-hidden="true"
                        />
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <div className="prose text-gray-500">
                      <ReactMarkdown>{faq.answer}</ReactMarkdown>
                    </div>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  );
};
